<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
    <mapfre-card [singleCard]="false" [additionalClasses]="'other-request-success fs-16'">
        <app-billing-comment [commentType]="requestType" [policy]="policy">
        </app-billing-comment>
    </mapfre-card>
</ng-container>